import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Form, Switch, Table, Select, Popconfirm, Button, Modal, Badge } from 'antd';
import { PageHeader } from '../../components/page-headers/page-headers';
import axios from '../../backendServiceWithoutTimeout';
import { GlobalUtilityStyle, PaginationStyle } from '../../container/styled';

function TransactionHistory() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchData = async () => {
    try {
      const response = await axios.get(`/transaction-history`);
      console.log(response.data.data, '-----------------------------------transaction data');
      setData(response.data.data.recordsToShow);
      setFilterData(response.data.data.recordsToShow);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //sort data
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(`/transaction-history`);
  //     // Sort the records by _id in descending order assuming the _id increments with each new record
  //     const sortedData = response.data.data.sort((a, b) => {
  //       return b._id.localeCompare(a._id);
  //     });
  //     setData(sortedData);
  //     setFilterData(sortedData); // Set the sorted data
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  useEffect(() => {
    fetchData();
  }, []);

  // const onSearchQueryChange = (e) => {
  //   setSearchQuery(e.target.value);
  // };

  // Filter the data based on the search query
  // const filteredData = data.filter((item) =>
  //   // item.teacherName.toLowerCase().startsWith(searchQuery.toLowerCase()),
  //   item.teacherName && item.teacherName.toLowerCase().startsWith(searchQuery.toLowerCase())

  // );

  useEffect(() => {
    const filteredData = data.filter((item) => item.userName.toLowerCase().includes(searchQuery.toLowerCase()));
    setFilterData(filteredData);
  }, [data, searchQuery]);

  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const columns = [
    // {
    //   title: 'User ID',
    //   dataIndex: 'user',
    //   key: 'user',
    // },
    {
      title: 'User',
      dataIndex: 'userName',
      key: 'userName',
      // align: 'center',
    },
    //     // Determine the type based on the presence of 'defaultPoints' or 'subscriptionPoints'
    // {
    //   title: 'Type',
    //   key: 'type',
    //   align: 'center',
    //   render: (text, record) => {
    //     if (record.defaultPoints > 0) {
    //       return 'Register';
    //     } else if (record.subscriptionPoints > 0) {
    //       return 'Subscribed';
    //     } else {
    //       return 'N/A';
    //     }
    //   },
    // },
    {
      title: 'My Referral Code',
      dataIndex: 'userRefCode',
      key: 'userRefCode',
      align: 'center',
    },
    {
      title: 'Used Referral Code',
      dataIndex: 'referralOwnerRefCode',
      key: 'referralOwnerRefCode',
      align: 'center',
    },
    {
      title: 'Code Owner',
      dataIndex: 'referralOwner',
      key: 'referralOwner',
      align: 'center',
    },
    {
      title: 'Default Points',
      dataIndex: 'defaultPoints',
      key: 'defaultPoints',
      align: 'center',
    },
    {
      title: 'My Referrals',
      dataIndex: 'listOfRefferals',
      key: 'listOfRefferals',
      render: (referredUsers) => (
        <span className="flex gap-1 items-center justify-start flex-wrap">
          {referredUsers && referredUsers.length
            ? referredUsers.map((user) => (
                <Badge
                  style={{
                    background: '#8231D3',
                  }}
                  count={user}
                />
              ))
            : 'N/A'}
        </span>
      ),
      // align: 'center',
    },
    {
      title: 'Total Points',
      dataIndex: 'totalPoints',
      key: 'totalPoints',
      align: 'center',
    },
  ];

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  {/* <div className="flex items-center justify-between gap-[15px]">
                    <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center">
                      Transaction History
                    </h1>
                    <Input
                      className="w-[150px]"
                      value={searchQuery}
                      onChange={onSearchQueryChange}
                      placeholder="Search by name..."
                    />
                  </div> */}

                  <div className="flex items-center justify-between gap-[15px] w-[150px]">
                    <h1 className="mb-0 flex-shrink-0 text-ellipsis text-[18px] font-semibold sm:text-center">
                      Transaction History
                    </h1>
                    <Input
                      className="flex-grow w-auto min-w-0" // Make the input flexible but don't let it shrink below a certain point
                      value={searchQuery}
                      onChange={onSearchQueryChange}
                      placeholder="Search by name..."
                    />
                  </div>
                </div>

                <div className="mt-0.5">
                  <>
                    <GlobalUtilityStyle>
                      <PaginationStyle>
                        <div className="ant-pagination-custom-style table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-transparent rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                          <Table
                            // dataSource={filteredData.sort((a, b) => b.id - a.id)}
                            dataSource={filterData}
                            columns={columns}
                            rowKey={(record) => record._id}
                            pagination={{
                              defaultPageSize: 7,
                              total: data.length,
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                              className:
                                '[&>.ant-pagination-total-text]:border-none ssm:[&>.ant-pagination-total-text]:w-full [&>.ant-pagination-total-text]:text-center [&>.ant-pagination-total-text]:text-dark dark:[&>.ant-pagination-total-text]:text-white87 [&>.ant-pagination-total-text]:font-medium [&>.ant-pagination-total-text]:text-[17px md:justify-center',
                            }}
                          />
                        </div>
                      </PaginationStyle>
                    </GlobalUtilityStyle>
                  </>
                </div>
              </div>
            </>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default TransactionHistory;
